import { render, staticRenderFns } from "./AtmBranches.vue?vue&type=template&id=31a6eeba&scoped=true&"
import script from "./AtmBranches.vue?vue&type=script&lang=js&"
export * from "./AtmBranches.vue?vue&type=script&lang=js&"
import style0 from "./AtmBranches.vue?vue&type=style&index=0&id=31a6eeba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6eeba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VDivider,VIcon,VSheet})
